import axios from 'axios';
import { EMeetingType, ICurrencyListResponse, IExchangeRateResponse } from '@src/types';
import { useRoomStore } from '@src/stores';

const getApiBaseUrl = () => {
    const meetingType = useRoomStore.getState().meetingType;
    if (meetingType === EMeetingType.WEBINAR) {
        return `${process.env.REACT_APP_WEBINAR_ENDPOINT}/api/calculator`;
    }
    return `${process.env.REACT_APP_SFU_API_URL}/api/calculator`;
};

export const fetchCurrencyList = async (): Promise<ICurrencyListResponse> => {
    const response = await axios.get<ICurrencyListResponse>(`${getApiBaseUrl()}/currency/list`);
    return response.data;
};

export const fetchExchangeRates = async (source: string): Promise<Record<string, number>> => {
    const response = await axios.get<IExchangeRateResponse[]>(`${getApiBaseUrl()}/currency/exchange-rates`, {
        params: {
            from: source,
        },
    });

    const data = response.data;
    if (!Array.isArray(data)) {
        return {};
    }

    const ratesMap = data.reduce((acc, item) => {
        if (item.from_currency === source) {
            acc[item.to_currency] = item.rate;
        }
        return acc;
    }, {} as Record<string, number>);

    return ratesMap;
};
